import { render, staticRenderFns } from "./AvailableDatasetsList.vue?vue&type=template&id=c6e61192&scoped=true"
import script from "./AvailableDatasetsList.vue?vue&type=script&lang=js"
export * from "./AvailableDatasetsList.vue?vue&type=script&lang=js"
import style0 from "./AvailableDatasetsList.vue?vue&type=style&index=0&id=c6e61192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e61192",
  null
  
)

export default component.exports